import { createApiInstance } from "./apiClient";

const url = process.env.REACT_APP_ORDER_API_URL;

const failureFromError = (error) => {
	const status = error.response?.status;
	const carriesDisplayMessage = status === 409;

	return {
		error: true,
		success: false,
		status,
		invalid: status === 400,
		conflict: status === 409,
		message: carriesDisplayMessage
			? error.response?.data?.errors?.[0]?.message
			: null
	};
};

export const createOrder = async (orderData) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/order/`, retry: true });

		return await instance
			.post(``, orderData)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}

				return failureFromError(error);
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getOrderData = async () => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/order/`, retry: true });

		const requestUrl = `current`;

		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getOrderDataById = async (orderId) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/order/`, retry: true });

		const requestUrl = `${orderId}`;

		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getOrderConfirmationData = async (orderId) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/order/`, retry: true });

		const requestUrl = `confirmation/${orderId}`;

		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getOrderPaymentData = async ({type}) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/order/`, retry: true });

		const searchParams = new URLSearchParams();
		if (type) searchParams.append("type", type);

		const requestUrl = `payment?${searchParams.toString()}`;

		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}

				return failureFromError(error);
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const deleteOrderCookies = async () => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/order/`, retry: true });

		const requestUrl = `cookies`;

		return await instance
			.delete(requestUrl)
			.then((response) => {
				if (response.status === 204)
					return {
						error: false,
						success: true
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};
